import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SecureTokenService } from './secure-token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const hasValidToken = !!SecureTokenService.getAccessToken();

    if (hasValidToken) {
      return true;
    }

    const wasExplicitlyLoggedOut = SecureTokenService.wasExplicitlyLoggedOut();
    sessionStorage.clear();
    if (wasExplicitlyLoggedOut) {
      SecureTokenService.markLoggedOut();
    }
    SecureTokenService.clearTokens();
    return this.router.createUrlTree(['login']);
  }
}
